module.exports = __webpack_public_path__ + "static/media/PDFimg.4ec226ff.png";